import { render, staticRenderFns } from "./SysNoticeModal__Style#Drawer.vue?vue&type=template&id=5fb87e05&scoped=true&"
import script from "./SysNoticeModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./SysNoticeModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./SysNoticeModal__Style#Drawer.vue?vue&type=style&index=0&id=5fb87e05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb87e05",
  null
  
)

export default component.exports